// translations/navigation.ts
export const translations = {
  en: {
    'nav.blog': 'Blog',
    'nav.pricing': 'Pricing',
    'nav.profile': 'Profile',
    'nav.signin': 'Sign In',
    'nav.signup': 'Register',
    'nav.convert': 'Convert Invoice',
    'nav.convertShort': 'Convert',
    'nav.convertMobile': 'Convert',
    'nav.features': 'Features',
    'nav.pdfToXRechnung': 'PDF to XRechnung',
    'nav.pdfToZugferd': 'PDF to ZUGFeRD',
    'nav.xrechnungToPdf': 'XRechnung to PDF',
    'nav.xrechnungViewer': 'XRechnung/XML Viewer',
    'header.mobile.convert': 'Convert',
    'header.features.pdfToXrechnung.description': 'For German public sector invoicing and government compliance',
    'header.features.pdfToCii.description': 'When your accounting system prefers CII format',
    'header.features.pdfToZugferd.description': 'For German B2B commerce and hybrid document needs',
    'header.features.xrechnungToPdf.description': 'When you need human-readable versions for printing',
    'header.features.xrechnungViewer.description': 'To validate and review files before sending',
  },
  de: {
    'nav.blog': 'Blog',
    'nav.pricing': 'Preise',
    'nav.profile': 'Profil',
    'nav.signin': 'Anmelden',
    'nav.signup': 'Registrieren',
    'nav.convert': 'Rechnung konvertieren',
    'nav.convertShort': 'Konvertieren',
    'nav.convertMobile': 'Konvertieren',
    'nav.features': 'Funktionen',
    'nav.pdfToXRechnung': 'PDF zu XRechnung',
    'nav.pdfToZugferd': 'PDF zu ZUGFeRD',
    'nav.xrechnungToPdf': 'XRechnung zu PDF',
    'nav.xrechnungViewer': 'XRechnung/XML Viewer',
    'header.mobile.convert': 'Konvertieren',
    'header.features.pdfToXrechnung.description': 'Für deutsche Behörden und öffentliche Aufträge',
    'header.features.pdfToCii.description': 'Wenn Ihr Buchhaltungssystem das CII-Format bevorzugt',
    'header.features.pdfToZugferd.description': 'Für deutsche B2B-Geschäfte und hybride Dokumente',
    'header.features.xrechnungToPdf.description': 'Wenn Sie lesbare Versionen zum Drucken benötigen',
    'header.features.xrechnungViewer.description': 'Zum Prüfen und Validieren vor dem Versand',
  }
};